// extracted by mini-css-extract-plugin
export const wrapper = "contact-module--wrapper--34ve-";
export const title = "contact-module--title--2qMmF";
export const highlighted = "contact-module--highlighted--2_LD7";